import dynamic from 'next/dynamic';
import React from 'react';
const Icon3Titles = dynamic(() => import('@/frontend/components/qecomps/Icon3Titles.tsx').then(x => x.default), { ssr: false })

import { useState, useEffect } from 'react'
import Component, { PageEl } from '@/frontend/components/qecomps/Component'
export default p => Component(p, Page, true);


const Page: PageEl = (props: {} & { [key: string]: any }, refresh, getProps, onLoad, onConnected, dies, isFront, z) => {


  useEffect(() => {

    if (window.innerWidth < 5500) {
      props.mobile = true;
      refresh()
    }

    props.nextWord = async (type: "easy" | "mid" | "hard") => {
      let store = JSON.parse(localStorage.getItem("elang") || "[]");

      if (type == "easy")
        store = store.filter(s => s.word != props.word);

      store.sort((a, b) => a.date - b.date); //olders top

      let target = store.filter(s => s.date < new Date().getTime())[0];

      let w = await API["elang"]({ word: target?.word });

      let date = new Date().getTime();
      if (type == "easy") {
        date += 3600000;
      }
      else if (type == "mid") {
        date += 900000;
      }
      else if (type == "hard") {
        date += 180000
      }

      if (target) {
        target.date = date;
      }
      else {
        store.push({ word: props.word, type, date });
      }

      localStorage.setItem("elang", JSON.stringify(store))
      props.word = w.word;
      props.mean = w.mean;
      props.image = "https://cdn.qepal.com/elang/" + w.image;
      props.sound = "https://cdn.qepal.com/elang/" + w.sound;
      refresh();
      setTimeout(() => {
        (document.getElementById("mplayer") as HTMLAudioElement).play();
      }, 100);
    }


    document.body.style.backgroundImage = `url("/darkcloud.webp")`
  }, [])

  return (
    <div style={{ direction: z.lang.dir as any, minHeight: "110vh" }}>

      <main className={z.styles.main}>
        {/* <HeaderBar
          gototop
          defaultValue={(props.query.s || "").replace(/-/g, " ")}
          nopaths
        /> */}


        <div className={z.styles.graybox} style={{ backgroundColor: "#150F20", color: "whitesmoke", minHeight: "100vh" }}>
          <div style={{ width: "100%" }}>

            <f-c style={{ backgroundColor: "#322955", minHeight: 50 }}>

              <sp-2 />
              <sp-2 />
              <svg style={{ color: "white" }} width={35} height={35} viewBox="0 0 16 14"> <path fill="currentColor" fill-rule="evenodd" d="M3.959.226a20.7 20.7 0 0 1 6.09 0a2.86 2.86 0 0 1 2.422 2.577c.217 2.444.288 4.856.088 7.326l-.001.068a.76.76 0 0 1-.477.664c-.392.154-.56.38-.56.708s.168.555.56.71a.76.76 0 0 1 .077 1.377c-.31.164-.665.26-1.03.273a100 100 0 0 1-7.55 0c-.655-.025-1.212-.298-1.597-.757c-.376-.449-.546-1.024-.546-1.603l.001-.076c-.17-2.906-.157-5.78.101-8.69A2.86 2.86 0 0 1 3.96.226M2.936 11.525v.044c0 .287.083.496.19.624c.097.116.25.211.507.221c2.196.083 4.367.092 6.557.03a2.2 2.2 0 0 1-.168-.875c0-.328.061-.619.168-.874a99 99 0 0 0-6.557.03a.8.8 0 0 0-.3.064a.6.6 0 0 0-.196.144c-.105.119-.19.312-.2.58zm7.875-7.747a.5.5 0 0 0-.444-.27H8.052a.5.5 0 0 0 0 1H9.4L7.499 7.19a.5.5 0 0 0 .408.79h2.605a.5.5 0 0 0 0-1H8.874l1.9-2.684a.5.5 0 0 0 .037-.52m-6.22-.085l.368-1.102l.367 1.102zm1.223-1.698l.677 2.03l.007.021l.382 1.147a.5.5 0 0 1-.949.316l-.271-.816H4.258l-.272.816a.5.5 0 1 1-.948-.316l.382-1.147l.007-.022l.677-2.03a.901.901 0 0 1 1.71 0" clip-rule="evenodd" /></svg>
              <sp-2 />
              <c-x>
                <f-19>کیو ای زبان</f-19><sp-2 />
                <f-11>آموزش لغت به سبک لایتنر</f-11>
              </c-x>
            </f-c>
            <w-x style={{ padding: 10, gap: 20, flexDirection: props.mobile ? "column" : "row", alignItems: props.mobile ? "center" : "start", justifyContent: props.mobile ? "center" : "start" }}>
              <img alt={"تصویر فلش کارت " + props.word} src={props.image} style={{ width: 250, height: 250, borderRadius: 5, margin: "0 20px" }} fetchPriority='high' />
              <div style={{ display: "flex", flexDirection: "column", alignItems: props.mobile ? "center" : "start" }}>
                {props.mobile ? <br-x /> : null}
                <h1 style={{ fontSize: 35, fontWeight: "bold" }}>{props.word}</h1>
                {props.mobile ? <>
                  <br-x />
                  <br-x />
                </> : null}
                <br-x />
                <h2 style={{ fontSize: 15, lineHeight: 1.8 }}>{props.mean}</h2>
                <br-x />
                <br-x />
              </div>
            </w-x>

            <audio id="mplayer" src={props.sound} controls style={{ width: "100%" }} />
            <br-x />
            <w-cc style={{ gap: 5, padding: 10 }}>
              <b-100 style={{ backgroundColor: "#75B7E9" }} className='btn btn-active' onClick={async () => { props.nextWord("easy"); }}>بلدم</b-100>
              <b-100 style={{ backgroundColor: "#D0B505" }} className='btn btn-active' onClick={async () => { props.nextWord("mid"); }}>سخت بود</b-100>
              <b-100 style={{ backgroundColor: "#E89090" }} className='btn btn-active' onClick={async () => { props.nextWord("hard"); }}>جدید بود</b-100>
            </w-cc>
            <p style={{ fontSize: 9, padding: 15 }}>ما اینجا ۱۵۰۰۰ کلمه با بیشترین فراوانی در زبان انگلیسی رو برای شما در ساده ترین محیط با هدف حداکثر تمرکز فلش کارت کردیم.</p>

            {/* {
              props.tracks.map(track => {
                return <PlayRow track={track} artist={props.artist} album={props.album || props.songName || "yes"} />
              })
            } */}


            <hr />

            <w-cc style={{ padding: 10, gap: 10, }}>
              {props.rands.map(r => {
                return <f-cc style={{ minWidth: 50 }}><a href={r.link}>
                  <f-12 style={{ color: "whitesmoke", textDecoration: "underline" }}>{r.word}</f-12></a></f-cc>
              })}
            </w-cc>


            <br-x />
          </div>
        </div>



      </main>

      {/* <FloatingBall /> */}
    </div>
  )
}



import type { GetServerSideProps, GetServerSidePropsContext } from 'next';
import Cacher from '@/backend/Cacher';
import { LDJSONArticle, LDJSONOrganization, LDJSONWebPage, LDJSONWebSite, Meta, toLocalISO } from '@/common/seo';
import SiteConfig from '@/common/SiteConfig';
import TextEndAbbreviation from '@/frontend/components/qecomps/TextEndAbbreviation';
import Cap from '@/frontend/components/qecomps/Cap';

export const getServerSideProps: GetServerSideProps = async (context: GetServerSidePropsContext) => {

  (global.Startup != "OK") ? (await (await import('@/startup.ts')).Starter()) : null

  var { email, lang, uid, userip, role, session, follows, pageid, cacher } = await global.SSRVerify(context, false)
  if (cacher) {
    return cacher
  }

  console.log("LANG:", lang)

  let keys = ["expassign", "edit", "more", "journalmaxlen", "code", "pages", "region", "dir", "creators", "copylink",
    "txtmt", "ff", "ffb", "andxcmnts", "free", "getservice", "copied", "partner", "leaveacomment", "firstcomment",
    "delete", "relserv", "support", "transactions", "viewxreplies", "reply", "buyedbefore",
    "pin", "pinned", "unpin", "translate", "delete", "remove", "toman", "qetoman", "usd", "usdt", "cad", "aud", "usdc",
    "trx", "tron", "owner", "partner", "user", "payasugo", "searchexample",
    "viewxmorereplies", "guaranteemode", "units", "from", "prchdis", "prchbuy",
    "journals", "guarantee", "price", "quota", "expiration", "rank", "textw", "unlimited",
    "morecomments", "account", "loginreg", "freeunlimit",
    "ctrlpanel", "myapps", "homeexplore", "explore", "deposit", "transfer", "withdraw", "transactions", "messages", "logout",
    "login", "loginreg", "logingoogle", "loginlinkedin", "orloginemail", "emailisnotvalid", "languagename", "code", "path",
    "emailisempty", "plzenturemail", "hmverfy", "backtopreviouspage", "confirm", "unitsfullname", "units"]

  if (session.path.length > 2) {
    keys.push("follow", "followed", "expnotfound", "onlyexptag", "privateserv", "showservid")
    keys.push("timfreeze", "token", "explaination", "days", "times", "expmaxfreelen", "expmanlen")
  }
  let nlangs = {}
  for (let l of Object.keys(global.langs[lang])) {
    if (keys.includes(l))
      nlangs[l] = global.langs[lang][l]
  }





  // await global.logdb.insertOne(log);

  // console.log(JSON.stringify(q,null,2))

  let m = db.collection("elang");

  const randomDocs = await m.aggregate([
    { $match: { rejected: { $ne: true }, "tracks.0": { $exists: false } } },
    { $sample: { size: 102 } }
  ]).toArray();

  // console.log(randomDocs)

  const randoms = (docs: Array<any>) => {
    return docs.map(d => {
      let url = global.devmode ? ("http://localhost:2000/elang/" + d.word) : ("https://qepal.com/elang/" + d.word);
      return { word: d.word, link: url }
    })
  }
  let rands = randoms(randomDocs);

  let word = context.query.word

  let doc = await m.findOne({ word })
  console.log("DOC:", doc)


  if (!doc) {
    return { notFound: true };
  }

  let image = `https://cdn.qepal.com/elang/${doc.image}`;
  let sound = `https://cdn.qepal.com/elang/${doc.sound}`;


  let title =`تلفظ صحیح | ${Cap(word as string)} | فلش کارت | معنی لغت `;

  let meta: Meta = {} as any;

  meta.title = title;
  meta.description = `معنی کلمه ${word} رو با فلش کارت کیو ای به حافظه بلند مدت بسپار.`;
  meta.canonical = `https://qepal.com/elang/${word}`
  meta.hrefLangs = [
    { code: "fa", url: meta.canonical },
    { code: "x-default", url: meta.canonical },
  ]
  meta.index = true;
  meta.follow = true;
  meta.og = {
    title: title,
    description: title,
    image: image,
    alt: title,
    locale: "fa_IR",
    type: "article",
    url: meta.canonical
  }
  meta.twitter = {
    card: image,
    description: title,
    image: image,
    site: "@qepal",
    title: title
  }

  meta.ldjsons = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": SiteConfig.meta[lang].title,
      "url": "https://qepal.com",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://qepal.com/fa/s/{search_term_string}",
        "query-input": "required name=search_term_string"
      }
    } as LDJSONWebSite,

    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": SiteConfig.meta[lang].title,
      logo: "https://cdn.qepal.com/qepal/qecircabs.webp",
      contactPoint: { "@type": "ContactPoint", telephone: "+98-21-74391640", areaServed: { "@type": "Country", "name": "IR" } },
      url: "https://qepal.com/",
      sameAs: ["https://www.instagram.com/qenews", "https://x.com/armincdn", "https://www.linkedin.com/in/armin-kardan"]
    } as LDJSONOrganization,


    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": title,
      "image": image,
      "url": meta.canonical,
      inLanguage: "fa",
      isPartOf: {
        "@type": "WebSite",
        "name": SiteConfig.meta[lang].title,
        "url": "https://qepal.com/"
      },
      mainEntity: {
        "@type": "Article",
        headline: title,
        image: [image],
        author: { "@type": "Person", "name": "Ethan Cardan", url: "https://qepal.com" },
        dateModified: toLocalISO(new Date(2025, 11, 1)),
        datePublished: toLocalISO(new Date(2025, 11, 1)),
        description: meta.description,
        publisher: {
          "@type": "Organization",
          "name": SiteConfig.meta[lang].title,
          "logo": { "@type": "ImageObject", url: "https://cdn.qepal.com/qepal/qecircabs.webp" }
        }
      } as LDJSONArticle,
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": meta.canonical
      }
    } as LDJSONWebPage,

  ]



  let pr = await Prosper({
    props:
    {
      title,
      word,
      image,
      sound,
      mean: doc.mean,
      rands,
      query: { ...context.query, path: session.path },
      session,
      nlangs,
      langs: global.langlist,
      meta,
      pageid,
    },
  }, context)


  Cacher.page.set(context, uid, pr);

  return pr
}